import { ReactElement } from 'react';

import { commonTranslationKeys } from '@dreryk/react-common';
import { DownloadIcon, DownloadLink, IconFillColor, Tooltip } from '@dreryk/react-components';

type DownloadMedicalDocumentLinkProps = {
   readonly url: string;
};

export const DownloadMedicalDocumentLink = (props: DownloadMedicalDocumentLinkProps): ReactElement => {
   return (
      <Tooltip content={commonTranslationKeys.download} testId={'downloadMedicalDocument'}>
         <DownloadLink
            testId={'downloadMedicalDocument'}
            url={props.url}
            icon={<DownloadIcon fillColor={IconFillColor.PRIMARY} testId={'download'} />}
         />
      </Tooltip>
   );
};
